import { useDispatch } from "react-redux";
import { deleteHotspot } from "../../redux";
import DeleteIcon from "remixicon-react/DeleteBinLineIcon";
import { iconSize } from "../../config";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    width: "24px",
    height: "24px",
    background: "#ffffff", // Normal background color (white)
    border: "none",
    borderRadius: "3px",
    cursor: "pointer",
    transition: "background 0.3s",

    "& .icon": {
      width: "14px", // Icon size
    },

    "&:hover": {
      background: "#E5F4FF", // Hover background color
    },
  },
}));

export default useStyles;

export function DeleteHotspot() {
  const classes = useStyles();
  const dispatch = useDispatch();
  return (
    <div className={classes.button} onClick={() => dispatch(deleteHotspot())}>
      <DeleteIcon size={iconSize} />
    </div>
  );
}
